<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <!-- <vx-tooltip class="position-icon" :text="$t('button.off_on')" position="top">
                <vs-switch color="success" class="mt-3" v-model="turnOnOff"></vs-switch>
            </vx-tooltip> -->

            <vx-tooltip class="position-icon" :text="$t('button.edit')" position="top">
                <feather-icon icon="EditIcon" class="action-success icon-btn mt-3"
                    svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editRecord" />
            </vx-tooltip>

            <vx-tooltip class="position-icon" text="Dịch vụ" position="top">
                <feather-icon icon="PackageIcon" class="action-success icon-btn mt-3"
                    svgClasses="h-5 w-5 hover:text-primary cursor-pointer" @click="editServicePackOfDepartment" />
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top" v-if="isPermissionAll">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                    svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
            </vx-tooltip>
        </div>
    </div>
</template>

<script>
import {isAPI, isRouter} from "../../../../../store/permission";
import {constAPI, constRouter} from "../../../../../store/constant";
export default {
    name: 'CellRendererActions',
    // data() {
    //     return {
    //         status: true,
    //     }
    // },
    // computed: {
    //     turnOnOff: {
    //         get() {
    //             return this.status;
    //         },
    //         set() {
    //             if (this.status) {
    //                 this.turnOffService()
    //             } else {
    //                 this.turnOnService()
    //             }
    //         }
    //     }
    // },
    // created() {
    //     this.status = this.params.data.enabled
    // },
    methods: {
        isPermissionAll() {
            return isAPI(this, constAPI.department_all)
        },
        editRecord() {
            this.$router.push(`/user/department-info?branchId=${this.params.data.organizationBranchId}&departmentId=${this.params.data.id}`).catch(() => {
            })
        },
        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá phòng ban "${this.params.data.departmentName}" không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.post('/department/delete/' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();
                this.$store.commit('DELETE_DEPARTMENT', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        },
        // turnOnService() {
        //     this.$vs.loading()
        //     this.$crm.post(`/department/enabled/${this.params.data.id}`).then(() => {
        //         this.$vs.loading.close()
        //         this.status = true
        //     }).catch((err) => {
        //         this.$vs.loading.close();
        //         return this.$vs.notify({
        //             text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         })
        //     })
        // },
        // turnOffService() {
        //     this.$vs.loading()
        //     this.$crm.post(`department/disabled/${this.params.data.id}`).then(() => {
        //         this.$vs.loading.close()
        //         this.status = false
        //     }).catch((err) => {
        //         this.$vs.loading.close();
        //         return this.$vs.notify({
        //             text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        //             iconPack: 'feather',
        //             icon: 'icon-alert-circle',
        //             color: 'danger'
        //         })
        //     })
        // },
        editServicePackOfDepartment() {
            this.$router.push(`/user/assign-services-branch?departmentId=${this.params.data.id}&organizationBranchId=${this.params.data.organizationBranchId}`).catch(() => {
            })
        },
    }
}
</script>

<style scoped></style>

